var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('TabView',[_c('TabPanel',{attrs:{"header":"ข้อมูลพื้นฐานระบบ"}},[_c('system-general')],1),_c('TabPanel',{attrs:{"header":"ข้อมูลจังหวัด, อำเภอ, ตำบล"}},[_c('system-country')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }